var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxPopup',{attrs:{"visible":_vm.showSurveyPop,"title":_vm.menuTitle,"height":850,"width":1280,"container":".v-application"},on:{"hidden":_vm.onHidden}},[_c('DxScrollView',{attrs:{"width":"100%","height":"100%","direction":"both"}},[_c('div',[_c('surveyComponent')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }